export const TelephoneNumberLabels = {
  NO_LABEL: 'no_label',
  TOLL_FREE: 'toll_free',
  COLLECT: 'collect',
  CHARGE_APPLIED: 'charge_applied',
  TTY: 'tty',
  CUSTOM: 'custom',
};

export const ASSISTANCE_URL = '/library';
